var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLineChartUp = function SvgLineChartUp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2,
    d: "M17.5 17.5H3.833c-.466 0-.7 0-.878-.09a.83.83 0 0 1-.364-.365c-.091-.178-.091-.412-.091-.878V2.5m14.167 4.167L13.4 10.152c-.124.132-.186.198-.26.232a.4.4 0 0 1-.211.037c-.082-.008-.162-.05-.323-.133l-2.714-1.41c-.16-.083-.241-.125-.323-.132a.4.4 0 0 0-.21.036c-.075.034-.137.1-.26.232L5.832 12.5"
  })));
};
export default SvgLineChartUp;